import React from "react";

import { Check } from "icons";

import { Typography } from "clearsense-ui/components";
import { Steward } from "components/Common/TableStyle";

export const CDE_COLUMNS = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    width: 200,
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: 250,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    render: row => <Steward name={row?.name} title={row?.role} />,
    width: 200,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    render: row => <Steward name={row?.name} title={row?.role} />,
    width: 200,
  },
  {
    dataIndex: "is_secured",
    key: "is_secured",
    title: "Secured CDE",
    width: 150,
    render: text => (
      <div className="whitespace-pre-line">{text === "" ? "No" : text}</div>
    ),
  },
  {
    dataIndex: "mapping_status",
    key: "mapping_status",
    title: "Mapping Status",
    width: 150,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "data_source_count",
    key: "data_source_count",
    title: "# Data Source",
    width: 100,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
];

export const ASSOCIATE_CDE_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "40%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "50%",
  },
  {
    title: "EnterPrise",
    key: "enterprise",
    dataIndex: "enterprise",
    render: row => <Typography>{row ? `Y - ${row.name}` : "N"}</Typography>,
    width: "50%",
  },
  {
    title: "",
    key: "checked",
    dataIndex: "checked",
    render: text =>
      text && <Check size={15} style={{ color: "rgb(34, 118, 251)" }} />,
    width: "20%",
  },
];
